import Lookup from 'src/componentes/select-async';
import DocumentoList from 'src/paginas/GestaoDocumentos/Documento/DocumentoListLookup';

const DocumentoLookup = ({ ...rest }) => {
  return (
    <Lookup
      labelKey="nome"
      valueKey="id"
      url="DocumentoLookup"
      clearable
      showSearch={true}
      showNew={false}
      searchComponent={DocumentoList}
      {...rest}
    />
  );
};

export default DocumentoLookup;
